module.exports = __webpack_public_path__ + "images/imagequick2.58f31c82.png";